import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * ProtectedRoute component
 * Wraps routes that require authentication
 * Redirects to login page if user is not authenticated
 *
 * @param {Object} props
 * @param {boolean} props.adminRequired - Whether admin privileges are required
 * @param {React.ReactNode} props.children - Child components to render
 */
const ProtectedRoute = ({ adminRequired = false, children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="protected-route-loading">
        <div className="loading-spinner"></div>
        <p>Verifying authentication...</p>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // If admin is required but user is not admin
  if (adminRequired && !isAdmin) {
    return (
      <div className="unauthorized-message">
        <h2>Unauthorized Access</h2>
        <p>You need administrator privileges to access this page.</p>
        <a href="/">Return to Home</a>
      </div>
    );
  }

  // If user is authenticated and has correct permissions, render children
  return children;
};

export default ProtectedRoute;
